/**
 * Catálogo de features de Renata Copilot.
 * Cada feature puede habilitarse/deshabilitarse por nicho × plan desde el admin.
 * Default (sin fila en DB) = todos habilitados.
 */

export const RENATA_COPILOT_FEATURES = [
  {
    id: "inbox",
    label: "Bandeja de entrada",
    description: "Upload, lista y vista previa de documentos capturados",
    mature: true,
  },
  {
    id: "ocr_capture",
    label: "Captura OCR / IA",
    description: "Procesamiento automático de facturas, remitos e imágenes",
    mature: true,
  },
  {
    id: "guided_review",
    label: "Revisión guiada",
    description: "Flujo interactivo para confirmar stock, proveedores y cambios detectados",
    mature: true,
  },
  {
    id: "chat",
    label: "Chat con Renata",
    description: "Interfaz conversacional en lenguaje natural",
    mature: false,
  },
  {
    id: "smart_buyer",
    label: "Comprador inteligente",
    description: "Gestión asistida de proveedores y órdenes de compra",
    mature: false,
  },
  {
    id: "planning",
    label: "Planning",
    description: "Órdenes sugeridas y planificación de stock",
    mature: false,
  },
  {
    id: "knowledge",
    label: "Base de conocimiento",
    description: "Indexación automática e inteligencia contextual del negocio",
    mature: false,
  },
] as const;

export type RenataFeatureId = (typeof RENATA_COPILOT_FEATURES)[number]["id"];

export const RENATA_FEATURE_IDS = RENATA_COPILOT_FEATURES.map((f) => f.id) as RenataFeatureId[];

/** Mapa de businessProfile (operacional) → nicheId (marketing) para lookup de flags. */
export const BUSINESS_PROFILE_TO_NICHE: Record<string, string> = {
  restaurant:   "restaurante",
  fast_food:    "restaurante",
  cafe:         "cafeteria",
  market:       "almacen",
  bazar:        "almacen",
  supermarket:  "almacen",
  butcher:      "carniceria",
  health:       "dietetica",
  fashion:      "indumentaria",
  clothing:     "indumentaria",
  digital:      "digital",
  servicios:    "servicios",
  catalog:      "almacen",   // default genérico
  default:      "almacen",
};

export function profileToNiche(businessProfile: string): string {
  return BUSINESS_PROFILE_TO_NICHE[businessProfile] ?? "almacen";
}
